<div class="terms container">
  @if (content$ | async; as content) {
    <span class="title" [innerHTML]="content.data?.title"></span>

    <p class="description" [innerHTML]="content.data?.description"></p>

    <div class="data-container">
      <div class="content-modal" [innerHTML]="content.data?.termsText"></div>
    </div>
  }
</div>
